var _g, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#23BD86"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#23BD86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8634 33.0001C24.5874 33.0001 24.3234 32.8861 24.1344 32.6851L19.2714 27.5061C18.8924 27.1041 18.9134 26.4711 19.3154 26.0931C19.7184 25.7151 20.3514 25.7351 20.7284 26.1371L24.8534 30.5281L33.2614 21.3261C33.6354 20.9171 34.2674 20.8901 34.6754 21.2621C35.0824 21.6341 35.1104 22.2671 34.7384 22.6741L25.6014 32.6741C25.4144 32.8801 25.1484 32.9981 24.8704 33.0001H24.8634Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreenCheck);
export default __webpack_public_path__ + "static/media/SuccessGreenCheck.a1fcc1fd.svg";
export { ForwardRef as ReactComponent };